// Minimal editorial-theme JS: variant selection, mobile menu, newsletter popup delay.
(function () {
  // Mobile menu
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-menu-open]');
    const c = e.target.closest('[data-menu-close]');
    if (t) document.querySelector('.mobile-menu')?.classList.add('is-open');
    if (c) document.querySelector('.mobile-menu')?.classList.remove('is-open');
  });

  // Variant select syncs into hidden id input + updates price
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    const form = sel.closest('form');
    if (!form) return;
    const opts = Array.from(form.querySelectorAll('[data-variant-select]')).map((s) => s.value);
    try {
      const variants = JSON.parse(form.dataset.variants || '[]');
      const match = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (match) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = match.id;
        const priceEl = document.querySelector('[data-product-price]');
        if (priceEl && match.price) priceEl.textContent = match.price;
        const btn = form.querySelector('[data-add-btn]');
        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available ? btn.dataset.addLabel : btn.dataset.soldLabel;
        }
      }
    } catch (_) {}
  });

  // Product qty
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    const cur = parseInt(input.value || '1', 10);
    const next = b.dataset.qty === 'up' ? cur + 1 : Math.max(1, cur - 1);
    input.value = String(next);
  });

  // Newsletter popup: show after 8s once per session (unless dismissed)
  const KEY = 'dt_nl_dismissed';
  const nl = document.querySelector('.nl-overlay');
  function openNL() {
    if (!nl) return;
    if (sessionStorage.getItem(KEY)) return;
    nl.classList.add('is-open');
  }
  function closeNL() {
    nl?.classList.remove('is-open');
    sessionStorage.setItem(KEY, '1');
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-nl-close]') || e.target.classList?.contains('nl-overlay')) closeNL();
  });
  if (nl) {
    // If Shopify redirected back with a success/error state, keep the popup open
    if (nl.dataset.nlForce === '1') {
      sessionStorage.removeItem(KEY);
      nl.classList.add('is-open');
      // Scroll form into view inside modal
      nl.querySelector('form')?.scrollIntoView({ block: 'center' });
    } else {
      setTimeout(openNL, 8000);
    }
  }

  // PDP gallery + variant buttons
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-pdp-thumb]');
    if (thumb) {
      showPdpImage(thumb.dataset.pdpThumb);
      return;
    }
    const vb = e.target.closest('[data-variant-option]');
    if (vb) {
      const form = vb.closest('form');
      const list = vb.parentElement;
      list.querySelectorAll('[data-variant-option]').forEach((b) => {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      vb.classList.add('is-active');
      vb.setAttribute('aria-pressed', 'true');
      const available = vb.dataset.variantAvailable === 'true';
      if (form) {
        const idInput = form.querySelector('[data-variant-id]');
        if (idInput) idInput.value = vb.dataset.variantOption;
        const btn = form.querySelector('[data-add-btn]');
        if (btn) {
          btn.disabled = !available;
          btn.textContent = available ? btn.dataset.addLabel : btn.dataset.soldLabel;
        }
      }
      document.querySelectorAll('[data-product-price]').forEach((el) => {
        if (vb.dataset.variantPrice) el.textContent = vb.dataset.variantPrice;
      });
      const stock = document.querySelector('[data-product-stock]');
      if (stock) stock.classList.toggle('is-hidden', !available);
      const imgId = vb.dataset.variantImageId;
      if (imgId) {
        const target = document.querySelector('[data-image-id="' + imgId + '"]');
        if (target) showPdpImage(target.dataset.pdpImage);
      }
      return;
    }
    const stickyAdd = e.target.closest('[data-pdp-sticky-add]');
    if (stickyAdd) {
      document.querySelector('.pdp__form-el [data-add-btn]')?.click();
    }
  });

  function showPdpImage(index) {
    document.querySelectorAll('[data-pdp-image]').forEach((img) => {
      img.classList.toggle('is-active', img.dataset.pdpImage === String(index));
    });
    document.querySelectorAll('[data-pdp-thumb]').forEach((b) => {
      b.classList.toggle('is-active', b.dataset.pdpThumb === String(index));
    });
  }

  // Safety net for Shopify product routes that incorrectly render the 404 template
  // while their product JSON endpoint is still public.
  const routeFallback = document.querySelector('[data-product-route-fallback]');
  if (routeFallback) hydrateProductRouteFallback(routeFallback);

  function hydrateProductRouteFallback(root) {
    const handle = root.dataset.productHandle;
    if (!handle) return;
    fetch('/products/' + encodeURIComponent(handle) + '.json', { headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('Product not found'))))
      .then((payload) => {
        if (!payload.product) throw new Error('Product not found');
        renderProductRoute(root, payload.product);
      })
      .catch(() => {
        root.innerHTML = '<section class="page" style="text-align:center"><h1 class="page__h1">Product not found</h1></section>';
      });
  }

  function renderProductRoute(root, product) {
    const labels = root.dataset;
    const images = (product.images || []).slice(0, 50);
    const variants = product.variants || [];
    const current = variants[0] || {};
    const formatMoney = (value) => {
      const amount = Number.parseFloat(value || '0');
      const locale = document.documentElement.lang && document.documentElement.lang.startsWith('de') ? 'de-DE' : 'en-US';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(Number.isFinite(amount) ? amount : 0);
    };
    const escapeHtml = (value) => String(value || '').replace(/[&<>"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char]));
    const formatVariant = (title) => String(title || '')
      .split(' / ')
      .map((part) => {
        const clean = part.trim();
        return /^[0-9]/.test(clean) ? clean : clean.charAt(0).toUpperCase() + clean.slice(1);
      })
      .join(' / ');
    const imageById = new Map(images.map((image) => [String(image.id), image]));
    const thumbs = images.map((image, index) => `
      <button type="button" class="pdp__thumb${index === 0 ? ' is-active' : ''}" data-pdp-thumb="${index}" aria-label="${escapeHtml(labels.labelImage)} ${index + 1}">
        <img src="${escapeHtml(image.src)}" alt="${escapeHtml(image.alt || product.title)}" width="180" height="180" loading="lazy">
      </button>
    `).join('');
    const mainImages = images.map((image, index) => `
      <img class="pdp__main-img${index === 0 ? ' is-active' : ''}" data-pdp-image="${index}" data-image-id="${escapeHtml(image.id)}" src="${escapeHtml(image.src)}" alt="${escapeHtml(image.alt || product.title)}" width="1200" height="1500" loading="${index === 0 ? 'eager' : 'lazy'}" ${index === 0 ? 'fetchpriority="high"' : ''}>
    `).join('');
    const variantButtons = variants.length > 1 ? `
      <div class="pdp__variants">
        <p class="caption text-muted">${escapeHtml(labels.labelVariant)}</p>
        <div class="pdp__variant-list">
          ${variants.map((variant, index) => {
            const image = imageById.get(String(variant.image_id)) || imageById.get(String(variant.featured_image && variant.featured_image.id));
            const available = variant.available !== false;
            return `<button type="button" class="pdp__variant${index === 0 ? ' is-active' : ''}" data-variant-option="${escapeHtml(variant.id)}" data-variant-price="${escapeHtml(formatMoney(variant.price))}" data-variant-available="${available}" data-variant-image-id="${escapeHtml(image ? image.id : '')}" aria-pressed="${index === 0 ? 'true' : 'false'}">${escapeHtml(formatVariant(variant.title))}</button>`;
          }).join('')}
        </div>
      </div>
    ` : '';
    root.outerHTML = `
      <nav class="pdp-crumb caption text-muted">
        <a href="/">${escapeHtml(labels.labelHome)}</a><span>/</span><a href="/collections/all">${escapeHtml(labels.labelShop)}</a><span>/</span><span class="pdp-crumb__current">${escapeHtml(product.title)}</span>
      </nav>
      <section class="pdp">
        <div class="pdp__media"><div class="pdp__thumbs">${thumbs}</div><div class="pdp__main">${mainImages}</div></div>
        <div class="pdp__info">
          <h1 class="pdp__h1">${escapeHtml(product.title)}</h1>
          <div class="pdp__price-row"><span class="pdp__price" data-product-price>${escapeHtml(formatMoney(current.price))}</span><span class="pdp__stock caption" data-product-stock>${escapeHtml(labels.labelStock)}</span></div>
          <div class="pdp__desc rte">${product.body_html || ''}</div>
          <form method="post" action="/cart/add" class="pdp__form-el">
            <input type="hidden" name="id" value="${escapeHtml(current.id)}" data-variant-id>
            ${variantButtons}
            <div class="pdp__buy"><div class="product__qty"><button type="button" data-qty="down" aria-label="Decrease quantity">−</button><input type="number" name="quantity" value="1" min="1" aria-label="Quantity"><button type="button" data-qty="up" aria-label="Increase quantity">+</button></div><button type="submit" name="add" class="btn btn-primary pdp__add" data-add-btn data-add-label="${escapeHtml(labels.labelAdd)}" data-sold-label="${escapeHtml(labels.labelSold)}">${escapeHtml(labels.labelAdd)}</button></div>
          </form>
          <ul class="pdp__trust"><li>${TRUST_ICONS.shipping}<span>${escapeHtml(labels.labelShippingTrust)}</span></li><li>${TRUST_ICONS.returns}<span>${escapeHtml(labels.labelReturnsTrust)}</span></li><li>${TRUST_ICONS.pay}<span>${escapeHtml(labels.labelPayTrust)}</span></li></ul>
          <div class="pdp__specs"><h2 class="caption text-muted">${escapeHtml(labels.labelDetails)}</h2><dl class="pdp__spec-grid"><div><dt>${escapeHtml(labels.labelMaterial)}</dt><dd>${escapeHtml(product.product_type)}</dd></div><div><dt>${escapeHtml(labels.labelOrigin)}</dt><dd>${escapeHtml(labels.labelOriginValue)}</dd></div></dl></div>
          <div class="product__meta"><details><summary>${escapeHtml(labels.labelCare)}</summary><p>${escapeHtml(labels.labelCareCopy)}</p></details><details><summary>${escapeHtml(labels.labelShipping)}</summary><p>${escapeHtml(labels.labelShippingCopy)}</p></details></div>
        </div>
      </section>
      <div class="pdp-sticky" data-pdp-sticky><div class="pdp-sticky__info"><p class="pdp-sticky__title">${escapeHtml(product.title)}</p><p class="pdp-sticky__price caption" data-product-price>${escapeHtml(formatMoney(current.price))}</p></div><button type="button" class="btn btn-primary" data-pdp-sticky-add>${escapeHtml(labels.labelAdd)}</button></div>
    `;
    translateProductCopy();
  }

  // Trust icons matching the Lovable site (Package / RotateCcw / ShieldCheck)
  var TRUST_ICONS = {
    shipping:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>',
    returns:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>',
    pay:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
  };

  // Product copy is authored in German. English descriptions are bundled with
  // the theme so locale switching does not depend on an external request.
  function translateProductCopy() {
    var pathLocale = window.location.pathname.split('/').filter(Boolean)[0] || '';
    var shopifyLocale = window.Shopify && window.Shopify.locale;
    var lang = (document.documentElement.lang || shopifyLocale || pathLocale || 'de').toLowerCase();
    if (lang.indexOf('en') !== 0) return;
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    var handle = match && match[1] ? decodeURIComponent(match[1]) : '';
    var translations = window.DT_PRODUCT_DESCRIPTIONS_EN || {};
    var translatedHtml = translations[handle];
    var description = document.querySelector('.pdp__desc');
    if (!description || !translatedHtml) return;
    description.innerHTML = translatedHtml;
    description.dataset.translated = '1';
  }

  translateProductCopy();
})();
